"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INotedocumentFrozen = exports.INotedocumentInactive = exports.INotedocumentType = void 0;
var INotedocumentType;
(function (INotedocumentType) {
    INotedocumentType["JPG_JPG"] = "jpg";
    INotedocumentType["JPEG_JPEG"] = "jpeg";
    INotedocumentType["GIF_GIF"] = "gif";
    INotedocumentType["PNG_PNG"] = "png";
    INotedocumentType["PDF_PDF"] = "pdf";
    INotedocumentType["TIF_TIF"] = "tif";
    INotedocumentType["TIFF_TIFF"] = "tiff";
    INotedocumentType["TXT_TXT"] = "txt";
    INotedocumentType["XML_XML"] = "xml";
    INotedocumentType["ASC_ASC"] = "asc";
    INotedocumentType["RTF_RTF"] = "rtf";
    INotedocumentType["CSV_CSV"] = "csv";
    INotedocumentType["XLS_XLS"] = "xls";
    INotedocumentType["DOC_DOC"] = "doc";
    INotedocumentType["ODT_ODT"] = "odt";
    INotedocumentType["ODS_ODS"] = "ods";
    INotedocumentType["_JSON"] = "json";
    INotedocumentType["_SOAP"] = "soap";
})(INotedocumentType = exports.INotedocumentType || (exports.INotedocumentType = {}));
var INotedocumentInactive;
(function (INotedocumentInactive) {
    INotedocumentInactive[INotedocumentInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    INotedocumentInactive[INotedocumentInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(INotedocumentInactive = exports.INotedocumentInactive || (exports.INotedocumentInactive = {}));
var INotedocumentFrozen;
(function (INotedocumentFrozen) {
    INotedocumentFrozen[INotedocumentFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    INotedocumentFrozen[INotedocumentFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(INotedocumentFrozen = exports.INotedocumentFrozen || (exports.INotedocumentFrozen = {}));
